/*
  Kampanya merkezi ve kampanya sayfaları.
  - Tazeleme: [data-kmp-kok] köklerinin data-sinir anı (epoch sn) geçince bölüm
    Section Rendering API ile yeniden istenir. Önbellekten eski gelen sayfa
    böylece kendini düzeltir (alix-surpriz.js ile aynı akış).
  - Geri sayım, kod kopyalama, sayfa içi tür süzme (adres değişmez),
    "Haber ver" formu (Klaviyo istemci aboneliği, açık rıza zorunlu).
  - dataLayer: kampanya_kart_tikla, kampanya_kod_kopyala, kampanya_haber_ver
*/
(function () {
  'use strict';
  var dl = (window.dataLayer = window.dataLayer || []);
  function olay(ad, veri) { try { dl.push(Object.assign({ event: ad }, veri || {})); } catch (e) {} }

  /* İstemci saati ile sunucu saati arasındaki fark: taslakta test saati kullanılınca da doğru sayar */
  function fark(kok) {
    var s = Number(kok.dataset.simdi || 0);
    if (!kok._fark) kok._fark = s ? s * 1000 - Date.now() : 0;
    return kok._fark;
  }
  function simdi(kok) { return Date.now() + fark(kok); }

  /* ---------- Tazeleme ---------- */
  function izle(kok) {
    var sinir = Number(kok.dataset.sinir || 0);
    if (!sinir) return;
    var bekle = sinir * 1000 - simdi(kok);
    if (bekle > 2147483000) return;
    setTimeout(function () { tazele(kok, 0); }, Math.max(0, bekle) + 1500);
  }
  function tazele(kok, deneme) {
    var id = kok.dataset.sectionId;
    if (!id) return;
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', id);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (y) { return y.ok ? y.text() : Promise.reject(y.status); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var yeni = tmp.querySelector('[data-kmp-kok]');
        if (!yeni) return;
        if (yeni.dataset.sinir === kok.dataset.sinir && deneme < 6) {
          setTimeout(function () { tazele(kok, deneme + 1); }, 30000);
          return;
        }
        kok.replaceWith(yeni);
        baslat(yeni);
      })
      .catch(function () { if (deneme < 6) setTimeout(function () { tazele(kok, deneme + 1); }, 30000); });
  }

  /* ---------- Geri sayım: sunucu HTML'i "-" yer tutucusuyla gelir, yer kaymaz (CLS) ---------- */
  function sayac(kok) {
    kok.querySelectorAll('[data-kmp-sayac][data-bitis]').forEach(function (el) {
      var bitis = Number(el.dataset.bitis || 0) * 1000;
      var g = el.querySelector('[data-g]'), s = el.querySelector('[data-s]'), d = el.querySelector('[data-d]');
      if (!bitis || !g) return;
      function yaz() {
        var k = Math.max(0, Math.floor((bitis - simdi(kok)) / 1000));
        g.textContent = Math.floor(k / 86400);
        s.textContent = Math.floor((k % 86400) / 3600);
        d.textContent = Math.floor((k % 3600) / 60);
        if (k > 0) setTimeout(yaz, 30000);
      }
      yaz();
    });
  }

  /* ---------- Kod kopyala ---------- */
  function kopya(kok) {
    kok.querySelectorAll('[data-kmp-kopya]').forEach(function (b) {
      b.addEventListener('click', function () {
        var kod = b.dataset.kmpKopya, em = b.querySelector('em');
        var bitti = function () { if (em) { em.textContent = 'Kopyalandı'; setTimeout(function () { em.textContent = 'Kopyala'; }, 2000); } };
        olay('kampanya_kod_kopyala', { kampanya_kodu: kod });
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(kod).then(bitti, function () { sec(b); });
        } else { sec(b); }
      });
    });
  }
  function sec(b) {
    var r = document.createRange(); r.selectNodeContents(b.querySelector('span') || b);
    var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
  }

  /* ---------- Tür süzme (adres değişmez) ---------- */
  function cipler(kok) {
    var grup = kok.querySelector('.kmp-cipler');
    if (!grup) return;
    grup.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kmp-cip]');
      if (!b) return;
      var t = b.dataset.kmpCip;
      grup.querySelectorAll('[data-kmp-cip]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      kok.querySelectorAll('.kmp-izgara > li[data-kmp-tur]').forEach(function (li) {
        li.hidden = !!t && li.dataset.kmpTur !== t;
      });
    });
  }

  /* ---------- Kart tıklaması ---------- */
  function kartlar(kok) {
    kok.addEventListener('click', function (e) {
      var a = e.target.closest('.kmp-kart a');
      if (a) olay('kampanya_kart_tikla', { kampanya_url: a.getAttribute('href') });
    });
  }

  /* ---------- Haber ver ---------- */
  function haber(kok) {
    var dlg = kok.querySelector('[data-kmp-haber-dialog]');
    if (!dlg) return;
    var form = dlg.querySelector('[data-kmp-haber-form]');
    var anahtar = dlg.querySelector('[data-kmp-haber-anahtar]');
    var durum = dlg.querySelector('[data-kmp-haber-durum]');
    var listeler = {};
    (form.dataset.listeler || '').split(/\s+/).forEach(function (s) {
      var p = s.split('='); if (p.length === 2 && p[1]) listeler[p[0].trim()] = p[1].trim();
    });
    kok.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kmp-haber]');
      if (!b) return;
      if (b.dataset.kmpHaber) anahtar.value = b.dataset.kmpHaber;
      durum.textContent = '';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var ep = dlg.querySelector('input[type=email]'); if (ep) ep.focus();
    });
    dlg.querySelector('[data-kmp-haber-kapat]').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!form.email.checkValidity()) { durum.textContent = 'Geçerli bir e-posta adresi yaz.'; return; }
      if (!form.riza.checked) { durum.textContent = 'Kaydolmak için onay kutusunu işaretle.'; return; }
      var liste = listeler[anahtar.value] || listeler.genel;
      if (!liste) { durum.textContent = 'Kayıt şu an alınamıyor. Bülten sayfasından kaydolabilirsin.'; return; }
      durum.textContent = 'Kaydediliyor…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.firma), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Kampanya haber ver: ' + anahtar.value,
              profile: { data: { type: 'profile', attributes: { email: email, properties: { kampanya_haber: anahtar.value } } } }
            },
            relationships: { list: { data: { type: 'list', id: liste } } }
          }
        })
      }).then(function (y) {
        if (y.status === 202 || y.ok) {
          durum.textContent = 'Kaydoldun. Kampanya başlayınca e-posta göndereceğiz.';
          form.reset();
          olay('kampanya_haber_ver', { kampanya: anahtar.value });
        } else { durum.textContent = 'Kayıt alınamadı. Birazdan tekrar dene.'; }
      }).catch(function () { durum.textContent = 'Bağlantı kurulamadı. Birazdan tekrar dene.'; });
    });
  }

  function baslat(kok) { izle(kok); sayac(kok); kopya(kok); cipler(kok); kartlar(kok); haber(kok); }
  function hepsi() { document.querySelectorAll('[data-kmp-kok]').forEach(baslat); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
})();
